import _Button from "@material-ui/core/esm/Button";
import _Fab from "@material-ui/core/esm/Fab";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import Slider from 'react-slick';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import ArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { withStyles } from '@material-ui/core/styles';
import Arrow from 'swag-client-common/components/partials/product-previews/components/arrow';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { getImageWithParams } from 'swag-client-common/utils/tricks';
import { LimitedEditionInStock } from '../../../../../info/limited-edition-in-stock';
import { LimitedEditionCountdown } from '../../../../../info/limited-edition-countdown';
import { LimitedEditionInStockStyle } from '../../../../../info/limited-edition-in-stock/limited-edition-in-stock';
import { LimitedEditionCountdownStyle } from '../../../../../info/limited-edition-countdown/limited-edition-countdown';
import { DEFAULT_BUTTON } from '../../../../../../constants/styles';
import CSSclasses from './product-previews.scss';
import STYLES from './product-previews-styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const settings = {
  arrows: true,
  mobileFirst: true,
  draggable: false,
  infinite: false,
  centerMode: false,
  nextArrow: /*#__PURE__*/React.createElement(Arrow, {
    side: "right"
  }),
  prevArrow: /*#__PURE__*/React.createElement(Arrow, {
    side: "left"
  }),
  variableWidth: true,
  initialSlide: 0
};
const styles = {
  moreImagesButton: _objectSpread({}, DEFAULT_BUTTON, STYLES.moreImagesButton, {
    opacity: 0.85,
    width: '161px',
    margin: 0
  }),
  fab: _objectSpread({}, DEFAULT_BUTTON, {
    opacity: 0.85,
    height: '46px',
    width: '46px',
    margin: 0
  })
};
const getLogoStyles = ({
  top,
  left,
  width,
  height,
  angle
}) => ({
  top: `${top}%`,
  left: `${left}%`,
  width: `${width}%`,
  height: `${height}%`,
  transform: `rotate(${angle}deg)`
});
const getLogoWrapperStyles = ({
  top,
  left,
  width,
  height
}) => ({
  top: `${top}%`,
  left: `${left}%`,
  width: `${width}%`,
  height: `${height}%`
});
const getSlidesToShow = () => isMobile() ? 2 : 4;
const ProductPreviews = ({
  logos,
  images,
  showMoreImageMode,
  shouldOptimize = true,
  fullScreenMode,
  onMoreImageModeChange,
  className = '',
  classes,
  neighboringPreviews: {
    next,
    previous
  },
  onChangeView,
  isLimitedEditionView
}) => {
  const slidesToShow = getSlidesToShow();
  const needToCenter = slidesToShow > images.length;
  const noPreviews = images.length <= 1;
  const renderPreview = ({
    isActive,
    rectangle,
    url,
    id
  }, index) => {
    const imageHasLogoUploaded = logos && logos[id] && logos[id].rect && rectangle;
    let logoWrapperStyles;
    let logoStyles;
    if (imageHasLogoUploaded) {
      logoWrapperStyles = !!rectangle && getLogoWrapperStyles(rectangle);
      logoStyles = getLogoStyles(logos[id].rect);
    }
    const previewUrl = shouldOptimize ? getImageWithParams({
      url,
      height: 90
    }) : url;
    return /*#__PURE__*/React.createElement("div", {
      key: `${id}-${index}`,
      className: classnames(CSSclasses.wrapper, {
        [CSSclasses.active]: isActive
      }),
      onClick: () => onChangeView(id)
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.inner
    }, imageHasLogoUploaded && /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.logoWrapper,
      style: logoWrapperStyles
    }, /*#__PURE__*/React.createElement("img", {
      className: CSSclasses.logo,
      style: logoStyles,
      src: logos[id].preview,
      alt: "Logo"
    })), /*#__PURE__*/React.createElement("img", {
      className: CSSclasses.productImage,
      src: previewUrl,
      alt: `Preview of ${id} variant`
    })), isActive && /*#__PURE__*/React.createElement("div", {
      className: CSSclasses['active-cover']
    }));
  };
  const renderPreviews = () => {
    const slidesToShow = Math.min(getSlidesToShow(), images.length);
    const isArrowUsed = images.length > slidesToShow;
    const sliderProperties = _objectSpread({}, settings, {
      arrows: isArrowUsed,
      slidesToShow,
      slidesToScroll: slidesToShow
    });
    return /*#__PURE__*/React.createElement(Slider, sliderProperties, images.map((image, index) => image.url && renderPreview(image, index)));
  };
  const onFabClick = step => () => {
    if (step !== null) {
      onChangeView(step);
    }
  };
  const prevFab = /*#__PURE__*/React.createElement(_Fab, {
    disabled: !previous,
    onClick: onFabClick(previous),
    className: classes.fab,
    "aria-label": "Previous image"
  }, /*#__PURE__*/React.createElement(ArrowLeft, null));
  const nextFab = /*#__PURE__*/React.createElement(_Fab, {
    disabled: !next,
    onClick: onFabClick(next),
    className: classes.fab,
    "aria-label": "Next image"
  }, /*#__PURE__*/React.createElement(ArrowRight, null));
  if (noPreviews) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, isLimitedEditionView && /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.limitedEditionContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.limitedEditionWidgets
    }, /*#__PURE__*/React.createElement(LimitedEditionInStock, {
      style: LimitedEditionInStockStyle.Big
    }), /*#__PURE__*/React.createElement(LimitedEditionCountdown, {
      style: LimitedEditionCountdownStyle.Big
    })), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.limitedEditionLabel
    }, "Limited Edition")));
  }
  if (fullScreenMode) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.buttonContainerRightFixed
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(CSSclasses.arrow, CSSclasses.animated),
      "data-button": "PreviousImage"
    }, prevFab), /*#__PURE__*/React.createElement("div", {
      className: classnames(CSSclasses.arrow, CSSclasses.animated),
      "data-button": "NextImage"
    }, nextFab)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, {
      [CSSclasses.limitedEditionContainer]: isLimitedEditionView
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.buttonContainerRight
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.arrow, CSSclasses.animated, {
      [CSSclasses.movedDown]: !showMoreImageMode
    }),
    "data-button": "PreviousImage"
  }, prevFab), /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.arrow, CSSclasses.animated, {
      [CSSclasses.movedDown]: !showMoreImageMode
    }),
    "data-button": "NextImage"
  }, nextFab), /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.desktopOnly, CSSclasses.animated, {
      [CSSclasses.movedDown]: !showMoreImageMode
    })
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: onMoreImageModeChange,
    variant: "contained",
    className: classnames(CSSclasses.button, classes.moreImagesButton),
    "data-button": "ToggleMoreImages"
  }, showMoreImageMode ? 'Hide images' : 'More images'))), isLimitedEditionView && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.limitedEditionWidgets
  }, /*#__PURE__*/React.createElement(LimitedEditionInStock, {
    style: LimitedEditionInStockStyle.Big
  }), /*#__PURE__*/React.createElement(LimitedEditionCountdown, {
    style: LimitedEditionCountdownStyle.Big
  })), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.limitedEditionLabel
  }, "Limited Edition")), /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.preview, {
      [CSSclasses.hideMoreImages]: !showMoreImageMode
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.overlay
  }), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.previewInner
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.slickContainer, {
      [CSSclasses.centered]: needToCenter
    })
  }, renderPreviews()))));
};
export const ProductPreviewsComponent = withStyles(styles)(ProductPreviews);